var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%","min-width":"355px","max-height":"99%","position":"relative"}},[_c('div',{staticStyle:{"width":"100%","height":"460px"}},[_c('Chart',{attrs:{"width":"100%","height":"100%","option":_vm.storeManager}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }